module.exports = __webpack_public_path__ + "img/icon-gate.89a8ac52.svg";